import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { TranslateModule } from '@ngx-translate/core';
import { ESearchPageInputComponent } from './e-search-page-input.component';
import {RouterModule} from "@angular/router";
import { NguCarousel,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguItemComponent } from '@ngu/carousel';
import { createCustomElement } from "@angular/elements";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DataPatternDirectiveModuleGeneric} from "@signature-it/ngx-generic/directives";
import {ProductSolrImageDirectiveModuleGeneric} from '@signature-it/ngx-generic/directives';
import {TaxonomyMenuModuleGeneric} from "@signature-it/ngx-entity/components/taxonomy-menu";
import {previewMediaModule} from "@signature-it/ngx-entity/components/entity-preview-media";
import {SafePipeModule, ReplaceTokensPipeArrayModule} from "@signature-it/ngx-generic/pipes";
import {EntityBlockModuleGeneric} from "@signature-it/ngx-entity/components/entity-block";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        NguCarousel,
        NguCarouselDefDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguItemComponent,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        DataPatternDirectiveModuleGeneric,
        ProductSolrImageDirectiveModuleGeneric,
        TaxonomyMenuModuleGeneric,
        previewMediaModule,
        SafePipeModule,
        ReplaceTokensPipeArrayModule,
        EntityBlockModuleGeneric,
    ],
    declarations: [ESearchPageInputComponent],
    exports: [ESearchPageInputComponent]
})

export class SearchPageInputModuleGeneric {
    constructor(private injector: Injector) {
        const SearchComponentComp = createCustomElement(ESearchPageInputComponent, {injector});
        !customElements.get('ngx-esearch-input') && customElements.define('ngx-esearch-input', SearchComponentComp);
    }
}
